module.exports = __webpack_public_path__ + "static/media/car-default-photo.04df8cdf.svg";